<template>
  <div>
    <div class="tab-pane slide-left active">
      <div class="row column-seperation">
        <div class="col-md-6">
          <contract-informations :contract="contract"></contract-informations>
          <!-- <payment :contract="contract"></payment> -->
          <div>
            <h5>Consignes</h5>
            <resource-form :model="instructions.model"
                           :schema="instructions.schema"
                           :triggers="instructions.triggers"
                           @submit="updateInstructions($event.data)"
                           :key="contract.id"
                           :contractTerminated="contract.terminated"
                           v-if="instructions.hasOwnProperty('schema')">
            </resource-form>
            <div v-else class="progress-circle-indeterminate progress-circle-success"></div>
          </div>
        </div>
        <div class="col-md-6">
            <contract-options :contract="contract"
                                :options="contract.contract_options"
                                :instructions="optionsInstructions">
            </contract-options>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  button {
    text-transform: uppercase;
  }
</style>

<script type="text/babel">
  import ContractInformations from 'components/Customer/ContractManagementContent/Domiciliation/ContractInformations'
  import Payment from 'components/Customer/ContractManagementContent/Domiciliation/Payment'
  import ContractOptions from 'components/Customer/ContractManagementContent/Domiciliation/ContractOptions'
  import ResourceForm from "components/Forms/ResourceForm"

  import { mapState, mapActions } from 'vuex'


  export default {
    name: 'Domiciliation',

    components: {
      ContractInformations,
      Payment,
      ContractOptions,
      ResourceForm,
    },

    computed: {
      ...mapState('contract', {
        contract: 'model',
        instructions: 'instructions',
        optionsInstructions: 'optionsInstructions'
      }),
    },

    methods: {
      ...mapActions('contract', [
        'updateInstructions',
      ])
    },

    data () {
        return {
            dataReady: false
        }
    },

    watch: {
        instructions (newVal, oldVal) {
            this.dataReady = true
        }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/Domiciliation.vue